import dynamic from "next/dynamic";

const StickerModal         = dynamic ( () => import ( "_components/molecules/stickerModal" ) );
const SlideUpModal         = dynamic ( () => import ( "_components/atoms/slideUpModal" ) );
const DonationOptionsModal = dynamic ( () => import ( "_components/molecules/donationOptionsModal" ) );
const ErrorModal           = dynamic ( () => import ( "_components/molecules/errorModal" ) );
const MagicChatModal       = dynamic ( () => import ( "_components/molecules/magicChatModal" ) );

import useStylesOverlay from "_styles/organisms/donationModals";

const DonationModals = ( {
	displayModal,
	handleModal,
	handleModalOptions,
	donationOption,
	broadcastId,
	closeDonationModals,
	toggleErrorModal,
	errorModal,
	broadcasterId,
	autoDonationModal
} ) => {

	const { classes } = useStylesOverlay ();
	const showOverlay = displayModal || donationOption || errorModal;

	return (
		<>

			<div
				className = { !showOverlay ? classes.overlay : classes.overlayShow }
				onClick   = { errorModal ? toggleErrorModal : handleModal }
			/>

			<SlideUpModal
				opened = { displayModal }
			>
				<DonationOptionsModal
					handleModal   = { handleModal }
					handleOptions = { handleModalOptions }
				/>
			</SlideUpModal>

			<SlideUpModal
				opened = { donationOption === "Sticker" && !errorModal ? true : false }
			>

				<StickerModal
					autoDonationModal = { autoDonationModal }
					broadcasterId     = { broadcasterId }
					broadcastId       = { broadcastId }
					closeModals       = { closeDonationModals }
					displayModal      = { donationOption === "Sticker" ? true : false }
					handleModal       = { handleModal }
					toggleErrorModal  = { toggleErrorModal }
				/>

			</SlideUpModal>

			<SlideUpModal
				onClose = { () => handleModal ( "back" ) }
				opened  = { donationOption === "MagicChat" && !errorModal ? true : false }
			>
				<MagicChatModal
					broadcasterId    = { broadcasterId }
					broadcastId      = { broadcastId }
					closeModals      = { closeDonationModals }
					displayModal     = { donationOption === "MagicChat" ? true : false }
					handleModal      = { handleModal }
					toggleErrorModal = { toggleErrorModal }
				/>
			</SlideUpModal>

			<SlideUpModal
				opened = { errorModal }
			>

				<ErrorModal
					broadcasterId    = { broadcasterId }
					toggleErrorModal = { toggleErrorModal }
				/>
			</SlideUpModal>
		</>
	);
};

export default DonationModals;
